<template>
    <div class="bg-white py-12">
        <div class="bg-white">
            <div class="flex overflow-x-auto">
                <div class="mx-auto flex space-x-12 whitespace-nowrap py-3 px-4 sm:px-6 lg:space-x-24 lg:px-8">

                    <a href="https://uchowanca.pl/calendar/#delivery">
                        <div class="flex items-center text-sm font-medium text-indigo-600">
                            <svg class="mr-2 flex-none w-6 h-6" x-description="Heroicon name: outline/truck"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 stroke-width="2"
                                 stroke="currentColor" aria-hidden="true">
                                <path
                                    d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round"
                                      d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"></path>
                            </svg>
                            <p>Cennik dostaw</p>
                        </div>
                    </a>

                    <a href="https://uchowanca.pl/calendar">
                        <div class="flex items-center text-sm font-medium text-indigo-600">
                            <svg class="mr-2 flex-none w-6 h-6" x-description="Heroicon name: outline/calendar"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                 stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                            </svg>
                            <p>Terminy dostaw</p>
                        </div>
                    </a>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuickLinks"
}
</script>

<style scoped>

</style>
